<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="location-search-tab">
    <div class="d-flex">
        <jhi-column-filter [request]="request" [resultSearch]="resultSearch" [filters]="filters" [eventName]="COLUMN_FILTER_EVENT_NAME"
                           class="flex-sm-grow-1"></jhi-column-filter>
    </div>
    <br/>
    <div class="row">
        <div class="col">
            <div class="mb-3 d-flex align-items-center">
                <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                <div style="margin-left: 10px;">
                    <a href (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></a>
                </div>
                <span *ngIf="isLoading" style="margin-left: 10px;" class="throbber"></span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="mb-3 d-flex justify-content-end">
                <button class="btn btn-outline-info" [routerLink]="['/', { outlets: { popup: 'breeding-method-edit-dialog' } }]" queryParamsHandling="merge">
					<i class="fa fa-asterisk fa-md" aria-hidden="true"></i> {{"new" | translate}}</button>
            </div>
        </div>
    </div>
    <div class="table-responsive" *ngIf="breedingMethods">
        <table class="table table-striped table-bordered table-curved" *ngIf="breedingMethods.length else nodata">
            <thead>
            <tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="sort.bind(this)">
                <th [jhiSortBy]="ColumnLabels.NAME"><span jhiTranslate="crop-settings-manager.breeding-method.columns.method-name"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.DESCRIPTION"><span jhiTranslate="crop-settings-manager.breeding-method.columns.description"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.GROUP"><span jhiTranslate="crop-settings-manager.breeding-method.columns.group"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.CODE"><span jhiTranslate="crop-settings-manager.breeding-method.columns.code"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.TYPE"><span jhiTranslate="crop-settings-manager.breeding-method.columns.type"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.DATE"><span jhiTranslate="crop-settings-manager.breeding-method.columns.date"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.CLASS_NAME"><span jhiTranslate="crop-settings-manager.breeding-method.columns.class"></span> <span class="fa fa-sort"></span></th>
                <th [jhiSortBy]="ColumnLabels.SNAME_TYPE_CODE"><span jhiTranslate="crop-settings-manager.breeding-method.columns.snameTypeCode"></span> <span class="fa fa-sort"></span></th>
                <th style="width: 95px;"><span jhiTranslate="crop-settings-manager.breeding-method.columns.action">Action</span></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let breedingMethod of breedingMethods; trackById: trackId; index as index">
                <td>{{breedingMethod.name}}</td>
                <td><span class="text-ellipsis" title="{{breedingMethod.description}}">{{breedingMethod.description}}</span></td>
                <td>{{breedingMethod.group}}</td>
                <td>{{breedingMethod.code}}</td>
                <td>{{breedingMethod.type}}</td>
                <td>{{breedingMethod.creationDate}}</td>
                <td>{{breedingMethod.methodClassName}}</td>
                <td>{{breedingMethod.snameTypeCode}}</td>
                <td class="text-center">
                    <button class="btn btn-sm btn-outline-info me-2" (click)="editBreedingMethod(breedingMethod)">
                        <i class="fa  fa-edit fa-md" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-info me-2" (click)="deleteBreedingMethod(breedingMethod)">
                        <i class="fa fa-trash fa-md" aria-hidden="true"></i>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
        <ng-template #nodata>
            <table class="table table-striped table-bordered table-curved">
                <thead>
                <tr>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td jhiTranslate="no.data"></td>
                </tr>
                </tbody>
            </table>
        </ng-template>
    </div>
    <div *ngIf="breedingMethods && breedingMethods.length">
        <div class="row">
            <div class="col">
                <div class="pagination-container">
                    <div class="pagination-box pagination-box-left">
                        <div>
                            <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                        </div>
                    </div>
                    <div class="pagination-box">
                        <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                        [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                    </div>
                    <div class="pagination-box pagination-box-right">
                        <div class="d-flex align-items-center">
                            <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                            <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="75">75</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
